import styled from 'styled-components'

const sizes = { small: 1366, medium: 1600 }

export const Container = styled.div`
  position: relative;

  display: flex;
  height: 73%;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 812px) {
    height: auto;
    width: 100%;
    flex-direction: column;
  }
`

export const Inputs = styled.div`
  position: relative; 
  width: 30%;
  height: 90%;

  margin: 1em;

  @media screen and (max-width: 812px) {
    width: 85%;
    height: auto;
  }

  &:after{
    display: block;
    position: absolute;
    top: 0;
    right: 0;

    content:"";
    width: 3px;
    height: 100%;

    border-radius: 1px;
    background: #fff;
    opacity: 0.9;
  }
`
export const PitStop = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  margin: 0.5em;
  width: 60%;
  height: 90%;

  @media screen and (max-width: 812px) {
    margin: 0;
    width: 90%;
    height: auto;
    margin-bottom: 1em;

    &::-webkit-scrollbar { width: 0.3em; }

  }
`

export const Image = styled.img`
  display: block;
  width: 100%;

  object-fit: contain;
  border-radius: 5px;
  box-shadow: 1px 0px 25px rgba(0, 0, 100, 0.5);
`

export const InputItem = styled.div`
  position: relative;
  width: 100%;
  
  display: flex;
  align-content: center;
  justify-content: flex-start;
`

export const InputGroup = styled.div`
  position: relative;
  width: 100%;

  &:nth-child(n+2){
    margin-top: 1em;
  }
`

export const Label = styled.div`
  width: ${props => props.width}%;

  &:nth-child(n+2){
    margin-left: 3em;
  }
`

export const Input = styled.div`
  width: ${props => props.width}%;
  margin: 0.2em 0;
`